import { createContext } from "react";

const LoadingContext = createContext({
  isLoading: true, // default to true
  showLoading: () => {},
  hideLoading: () => {},
});

export default LoadingContext;
